// extracted by mini-css-extract-plugin
export default {"innerContainer":"styles-module--innerContainer--QXxjd","container":"styles-module--container--jqnpZ","socialLink":"styles-module--socialLink--kDZaF"};